import { QuickOnboardingSteps } from "features/quickOnboarding/types";

export const QUICK_ONBOARDING_STEP_TO_DESCRIPTION = {
  [QuickOnboardingSteps.CONNECT_EXCHANGE]:
    "Securely link your account to get started.",
  [QuickOnboardingSteps.CREATE_BOT]:
    "Customize your strategy in just a few clicks.",
  [QuickOnboardingSteps.MONITOR_PROGRESS]:
    "Track your bot's performance and refine your approach.",
};

export const ANIMATION_WIDTH = 520;
export const ANIMATION_HEIGHT = 538;

export const SMALL_MOBILE_ANIMATION_WIDTH = 400;
export const SMALL_MOBILE_ANIMATION_HEIGHT = 415;

export const QUICK_ONBOARDING_KEY = "quick_onboarding";
export const TELEGRAM_VIEW_SIGNAL_KEY = "telegram_view_signal";

export const LINE_STEP_HEIGHT = 4;
export const LINE_STEPS_MARGIN_TOP = 24;

export const BUTTON_HEIGHT = 52;
export const BUTTON_MARGIN = 32;
export const CONTENT_MAX_HEIGHT = 142;
